import axios from 'axios'
import { MessageBox, Toast } from 'mint-ui'
import store from '@/data/store'
import { getToken, setToken } from '@/common/permission/auth'
import { getChannel } from '@/common/utils/cookieHandler'

// import router from '@/router'
// import Cookie from '@/common/utils/Cookie.js'

// function getPargm () {
//   let channel = router.app.$route.query.channel && parseInt(router.app.$route.query.channel) > 0 ? 'lz' + String(router.app.$route.query.channel) : 'lz0'
//   Cookie.set('X-Saic-Channel', channel)
//   return channel
// }

// 创建axios实例
// let base = 'api'
const service = axios.create({
  // api的base_url
  // baseURL: base,
  // request timeout 请求超时时间
  timeout: 15000
})

service.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
service.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest'
service.defaults.responseType = 'json'

// request interceptor request拦截器
service.interceptors.request.use(config => {
  // 配置config
  config.headers.Accept = 'application/json'
  // 设置请求头
  // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  config.headers['Authorization'] = 'Bearer ' + getToken()
  config.headers['X-Saic-Channel'] = getChannel()
  if (config.url.indexOf('/auth/v2/login/passenger/mobile') !== -1) {
    // 乘客登录获取token接口
    config.headers['X-Saic-App-Version'] = '1.0.1'
    config.headers['X-Saic-Device-Id'] = '862777240313742_20360445999999'
    config.headers['X-Saic-Platform'] = 'h5'
  }
  return config
}, error => {
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    const res = response.data
    /* eslint-disable */
    if (res.errCode !== 0) {
      store.dispatch('addErrorLog', {
        err: {
          message: res.errMsg.replace(/\n/g, '<br>')
        },
        http: {
          headers: JSON.stringify(response.config.headers),
          url: response.config.url,
          code: response.data.errCode,
          params: response.config.params
        },
        url: window.location.href,
        time: new Date()
      })
      Toast({
        message: res.errMsg,
        position: 'middle',
        duration: 5 * 1000
      })
      // 若不是正确的返回code，且已经登录，就抛出错误
      const err = new Error(res.errMsg)
      throw err.response = response
      return res
    } else {
      if(response.headers.token){
        setToken(response.headers.token)
      }
      return response.data.data||response.data.result
    }
  },
  error => {
    if (!error.response) {
      // 没有请求 api 的权限
      if (error.config.url.indexOf('receive/samplingreceiver/receivedata') === -1) {
        // 除去上报打点接口外其他网络异常 弹窗提醒
        MessageBox.alert('网络错误！')
        const err = new Error('网络错误！')
        throw err.response = error.message
      }
      return false
    }    
    switch (error.response.status) {
      case 400:
        error.message = '请求错误'
        break
      case 401:
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消'
        }).then(() => {
          store.dispatch('fedLogOut').then(() => {
            location.reload()
          })
        })
        return false
        break
      case 403:
        error.message = '拒绝访问'
        break
      case 404:
        error.message = `请求地址出错: ${error.response.config.url}`
        break
      case 408:
        error.message = '请求超时'
        break
      case 500:
        error.message = '服务器内部错误'
        break
      case 501:
        error.message = '服务未实现'
        break
      case 502:
        error.message = '网关错误'
        break
      case 503:
        error.message = '服务不可用'
        break
      case 504:
        error.message = '网关超时'
        break
      case 505:
        error.message = 'HTTP版本不受支持'
        break
      default:
        error.message = '网络异常'
        break
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    const err = new Error(error.message)
    throw err.response = error.message
  })

export default service



// WEBPACK FOOTER //
// ./src/common/utils/request.js